import React from 'react';

import { Card, CardContent, CardHeader } from '@/components/ui/card';
import { Skeleton } from '@/components/ui/skeleton';

export function CardSkeleton({
  className,
  style,
}: {
  className?: string;
  style?: React.CSSProperties;
}) {
  // Uses semantic color tokens for a neutral skeleton
  return (
    <Card
      className={`relative flex aspect-[3/4] flex-col overflow-hidden bg-stone-100 ${className || ''}`}
      style={style}
    >
      {/* Image Area Skeleton */}
      <Skeleton className="absolute inset-0 h-full w-full bg-stone-200 " />

      {/* Tags Skeleton (Top Left) */}
      <div className="absolute left-2.5 top-2.5 z-[3] flex flex-wrap gap-1">
        <Skeleton className="h-5 w-10 rounded-sm bg-stone-300" />
        <Skeleton className="h-5 w-12 rounded-sm bg-stone-300" />
      </div>

      {/* Actions Popover Skeleton (Top Right) - just a small circle */}
      <div className="absolute right-1.5 top-1.5 z-[3]">
        <Skeleton className="h-8 w-8 rounded-full bg-stone-300" />
      </div>

      {/* Content Skeleton (Bottom Left) */}
      <div className="relative z-[2] mt-auto flex flex-grow flex-col p-3.5 text-transparent">
        <div className="mt-auto w-full">
          <div className="mr-8 overflow-hidden">
            <CardHeader className="mb-1 p-0">
              <Skeleton className="mb-1 h-6 w-3/4 rounded bg-stone-300" />{' '}
              {/* Title */}
              <Skeleton className="h-3 w-full rounded bg-stone-200" />{' '}
              {/* Description line 1 */}
              <Skeleton className="mt-1 h-3 w-5/6 rounded bg-stone-200" />{' '}
              {/* Description line 2 */}
            </CardHeader>
            <CardContent className="mt-1.5 p-0">
              <div className="space-y-1">
                <Skeleton className="h-3 w-1/2 rounded bg-stone-200" />{' '}
                {/* Detail line 1 */}
              </div>
            </CardContent>
          </div>
        </div>
      </div>
    </Card>
  );
}
